import Resolver from "@/api/resolver";
import Vue from "vue";
import { MutationTree } from "vuex";
import { initialState } from ".";
import { ProfileState } from "./types";

export const mutations: MutationTree<ProfileState> = {
  reset(state: Record<string, any>) {
    const s: Record<string, any> = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  profileLoaded(state, user: any) {
    state.error = false;
    state.data = user;
  },
  system(state, payload: any) {
    state.system = payload;
    state.systemLoaded = true;
  },
  accessRequest(state, result: any) {
    state.accessRequestResult = result;
  },

  demo(state) {
    Resolver.setup({
      now: state.system.demo.now + "+00:00",
      dateTimeOffset: "+00:00"
    });

    state.data = state.system.demo.user;
  },
  setArea(state, area: string) {
    state.area = area;
  },
  setAreas(state, areas: string[]) {
    state.data.areas = areas;
  },
  setAudioAlertsEnabled(state, enabled: boolean) {
    state.audioAlertsEnabled = enabled;
  },
  setAlertRepeatInterval(state, interval: number) {
    state.alertRepeatInterval = interval;
  },
  setSpeechSynthesisEnabled(state, enabled: boolean) {
    state.speechSynthesisEnabled = enabled;
  },
  setMaskMode(state, mask: boolean) {
    state.data.mask = mask;
  },
  setActiveCaseTests(state, tests: any[]) {
    state.activeTestList = tests;
  },
  setIsWirelessTesting(state, isTesting: boolean) {
    state.data.isTesting = isTesting;
  },
  setPagerID(state, pagerID: string) {
    state.data.pagerID = pagerID;
  },
  setPreference(state, data) {
    Vue.set(state.preferences, data.key, data.value);
  },
  setShownLoginMs(state, shown: boolean) {
    state.hasShownLoginMs = shown;
  }
};
